export enum ColumnId {
  name = 'name',
  engagementRate = 'engagementRate',
  followers = 'followers',
}

export default ColumnId;
